import request from 'axios';

/* ACTION CONSTANTS
================================================================================================ */
const FETCH_SUGGESTED_CREATIVES = 'crowdspring/project_1_1/FETCH_SUGGESTED_CREATIVES';
const FETCH_SUGGESTED_CREATIVES_REQUEST = 'crowdspring/project_1_1/FETCH_SUGGESTED_CREATIVES_REQUEST';
const FETCH_SUGGESTED_CREATIVES_SUCCESS = 'crowdspring/project_1_1/FETCH_SUGGESTED_CREATIVES_SUCCESS';
const FETCH_SUGGESTED_CREATIVES_FAILURE = 'crowdspring/project_1_1/FETCH_SUGGESTED_CREATIVES_FAILURE';

const SELECT_CREATIVE = 'crowdspring/project_1_1/SELECT_CREATIVE';

const SET_NEGOTIATION_ACTION = 'crowdspring/project_1_1/SET_NEGOTIATION_ACTION';

const SHOW_PAYMENT_MODAL = 'crowdspring/project_1_1/SHOW_PAYMENT_MODAL';


/* INITIAL STATES
================================================================================================ */
export const initialState = {
  isFetching: false,
  isError: true,
  suggestedCreatives: [],
  selectedCreative: null,
  negotiationAction: null,
  showingPaymentModal: false
};


/* HELPERS
================================================================================================ */
export const advanceNegotiationRequest = (projectId, data) => (
  request.patch(`/api/v1/projects/${projectId}/one_to_one_negotiation/`, data)
)


/* REDUCERS
================================================================================================ */
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUGGESTED_CREATIVES_REQUEST:
      return {
        ...state,
        isFetching: true,
        isError: false,
        selectedCreative: null,
        suggestedCreatives: []
      }
    case FETCH_SUGGESTED_CREATIVES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        suggestedCreatives: action.payload
      }
    case FETCH_SUGGESTED_CREATIVES_FAILURE:
      return {
        ...state,
        isFetching: false,
        isError: true
      }
    case SELECT_CREATIVE:
      return {
        ...state,
        selectedCreative: action.data
      }
    case SET_NEGOTIATION_ACTION:
      return {
        ...state,
        negotiationAction: action.data
      }
    case SHOW_PAYMENT_MODAL:
      return {
        ...state,
        showingPaymentModal: action.data
      }
    default:
      return state;
  }
};

export default reducer;


/* ACTION CREATORS
================================================================================================ */
export const fetchSuggestedCreatives = (subcatId, excludeIds=[]) => (dispatch, getState) => {
  /* fetch in progress */
  if (getState().project.projectPage.project1To1.isFetching) {
    return Promise.resolve()
  }

  const params = excludeIds.reduce((acc, id) => `${acc}exclude=${id}&`, '?');

  return dispatch({
    type: FETCH_SUGGESTED_CREATIVES,
    promise: request.get(`/api/v1/project-subcategories/${subcatId}/suggested_creatives/${params}`),
  });
}

export const selectCreative = (creative) => (dispatch, getState) => {
  return dispatch({
    type: SELECT_CREATIVE,
    data: creative
  });
}

export const setNegotiationAction = (action) => (dispatch, getState) => {
  return dispatch({
    type: SET_NEGOTIATION_ACTION,
    data: action
  });
}

export const showPaymentModal = (value) => (dispatch, getState) => {
  return dispatch({
    type: SHOW_PAYMENT_MODAL,
    data: value
  });
}



// WEBPACK FOOTER //
// ./project/ducks/project_1_1.jsx